import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RasterDepthComponent } from '../raster-depth/raster-depth.component';

@Component({
  selector: 'app-dialog-raster',
  templateUrl: './dialog-raster.component.html',
  styleUrls: ['./dialog-raster.component.css'],
  template: 'passed in {{ data.id, data.x, data.y, data.rasterIds, data.button }}'
})
export class DialogRasterComponent {

  constructor(
    private  dialogRef:  MatDialogRef<RasterDepthComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { id: string, x: number, y: number, rasterIds: string, buttonCancel: string }) { 
      
    }

    closeDialogRaster(close: boolean)
    {
      if (close) this.dialogRef.close();
    }
    

  

}
